const headerTypes = Object.freeze({
  Classic: 1,
  UnderChildren: 2,
  UnderAndAboveChildren: 3,
  LineHeader: 4,
  Root: 5
})

export { headerTypes }



// WEBPACK FOOTER //
// ./src/components/report-tables/enums/headerTypes.js